@Pipe({
  name: 'trueFalseToSiNo'
})
export class TrueFalseToSiNo implements PipeTransform {
  transform(value: any): string {
    if (value === true) {
      return 'Sí';
    }
    if (value === false) {
      return 'No';
    }
     if (value === null || value === undefined) {
       return '';
     }
     return value.toString();
  }
}

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'oneToNo'
})
export class OneToNo implements PipeTransform {
  transform(value: any): string {
    if (value === 1) {
      return 'Inactivo';
    }else{
      return 'Activo';
    }
    return value.toString(); // Devuelve el valor como string si no es 0
  }
}
@Pipe({
  name: 'nullToNo'
})
export class NullToNo implements PipeTransform {
  transform(value: any): string {
    if (value === null   || value === undefined) {
      return 'No';
    }
    return value.toString(); // Devuelve el valor como string si no es 0
  }
}
@Pipe({
  name: 'siNoUniversal'
})
export class SiNoUniversal implements PipeTransform {
  transform(value: any): string {
    if (value === true || value === 1 || value === "1") {
      return 'Sí';
    }
    if (value === false || value === 0 || value === "0") {
      return 'No';
    }
    if (value === null || value === undefined) {
      return '';
    }
    return value.toString();
  }
}
